<template>
    <div class="w-full flex flex-col min-h-[300px]">
        <div class="w-full flex-1 flex items-center justify-center text-center flex-col p-3">
            <span>{{error}}</span>
        </div>
        <div class="w-full px-4 box-border">
            <Button label="Start over" class="w-full mt-4" @click="resetStore"/>
        </div>
    </div>
</template>

<script setup>
import Button from "@/components/Button.vue";
import {useDonationStore} from "@/store/useDonationStore";

const {resetStore} = useDonationStore();

const props = defineProps({
    error: {
        type: [String, null],
        required: true,
    }
})
</script>